import styled from 'styled-components';

export const RespostaContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;